const util = {

    locale: 'en',

    availableLocale: {
        'en': 'en',
        'kr': 'ko',
        'ja': 'ja',
    },



    displaySuccessMessage(title, html) {
        Toast.fire({
            title: title,
            html: html
        })
    },



    displayErrorMessage(title, html) {
        Swal.fire({
            icon: 'error',
            title: title,
            html: html
        })
    },



    triggerSpinner(button) {
        $('#' + button.id + '-spinner').show()
        $('#' + button.id).prop('disabled', true);
    },



    stopSpinner(button) {
        $('#' + button.id + '-spinner').hide()
        $('#' + button.id).prop('disabled', false);
    },



    hideError(input) {
        $('#' + input.id + '-message').hide();
        $('#' + input.id).css('border', '');
    },



    setEventLivewire(event, data) {
        window.livewire.emit(event, data);
    },


    setLocale(key) {
        util.locale = util.availableLocale[key ? key : 'en']
        i18next.changeLanguage(key)
    },



    displayLanguageLoading() {
        $('#loading-language-transparent').show()
    },


    displayLoading() {
        $('#loading-transparent').show()
    },

    onHideLoading() {
        $('#loading-transparent').hide()
    },

    onEventListeners() {

        util.onLivewireEventListener()

    },

    onCloseSideBarEventListener() {

        $('#sidebarCollapse').on('click', function() {
            $('#sidebar').toggleClass('active');
            $(this).toggleClass('active');
        });

    },



    onLivewireEventListener() {

        window.livewire.on('swal:error', data => {
            util.displayErrorMessage(data.title, data.html);
            $('.modal').modal('hide');
            $('.modal-backdrop').remove()
        })

        window.livewire.on('swal:success', data => {
            util.displaySuccessMessage(data.title, data.html)
            if(data.modalId) {
                $(data.modalId).modal('hide');
                return;
            }
            $('.modal').modal('hide');
        })

        window.livewire.on('languageUpdate', key => {
            util.setLocale(key);
        })

        window.livewire.on('points:get', event => {
            $(`#current_points-${event.workspace_id}`).text(event.points);
        })
    },


    onCloseWorkspaceUserDetailsModal() {
        $('body').on('hidden.bs.modal', function() {
            // Livewire.emit('workspaceUserUpdated')
        })
    },


    updateSpaceData(id) {
        var validUntilText = $(`#validUntil-${id}`).text().trim()
        if (validUntilText) {
            var validUntilDate = new Date(validUntilText)
            var maxDate = flatpickrUtil.maxDateTwoYearsFromNow()
            if (validUntilDate > maxDate) {
                Swal.fire({
                    icon: 'error',
                    title: 'Validation Error',
                    text: 'Valid Until must be within 2 years from now.'
                })
                return
            }
        }
        api.updateSpaceData({
            workspace_id: id,
            width: $(`#width-${id}`).val(),
            height: $(`#height-${id}`).val(),
            capacity: $(`#capacity-${id}`).val(),
            date: validUntilText,
            archived_at: $(`#archivedAt-${id}`).text(),
            operator_accessible_until: $(`#operatorAccessibleUntil-${id}`).text(),
            domain: $(`#domain-${id}`).val(),
            x: $(`#spawn_avatars-x-${id}`).val(),
            y: $(`#spawn_avatars-y-${id}`).val(),
            points: $(`#points-${id}`).val(),
            ttl: $(`#ttl-${id}`).val(),
            experimentals: $(`#experimentals-${id}`).val(),
            organization_id: $(`#organization_id-${id}`).val()
        })
    },



    updateUserData(id) {
        api.updateUserData({
            user_id: id,
            email: $(`#email-${id}`).val(),
            email_verified_at: $(`#emailVerifiedAt-${id}`).text(),
            operator: $(`#operator-${id}`).prop("checked")
        })
    },

    deleteFloorsFromHtml(building_id) {
        var ul = document.querySelector(`#floors-list-${building_id}`);
        while (ul.firstChild) {
            ul.removeChild(ul.firstChild);
        }
        initFloors()
    },

    updateBuildingData(building_id, name, organization_id) {
        api.updateBuildingData(building_id, name, organization_id)
    },

    updateBuilding(building_id) {
        const ul = document.querySelectorAll(`#floors-list-${building_id} li span a span`);
        var floors = [];
        for (let i = 0; i <= ul.length - 1; i++) {
            if (ul[i].innerText) {
                floors.push(ul[i].innerText);
            }
        }
        // Correctly select the building name
        const buildingName = document.querySelector(`#building-${building_id}-detail h4`)?.getAttribute('data-building-name') || null;

        api.updateBuilding(building_id, buildingName, floors);
    },

    onCloseBuildingFloorsModal() {
        $('body').on('hidden.bs.modal', function(modal) {
            let id = modal.target.attributes.data.value
            let element = document.querySelector(`#input-floor-${id}`)
            if(!element) {
                return
            }
            element.value = '';
            Livewire.emit('buildingUpdated')
            window.initFloors()
        })
    },

    onCloseWorkspaceDetailsModal() {
        $('body').on('hidden.bs.modal', function() {
            Livewire.emit('workspaceUpdated')
        })
    },

    onCloseWorkspaceLayoutDetailsModal() {
        $('body').on('hidden.bs.modal', function() {
            Livewire.emit('layoutUpdated')
            Livewire.emit('resetVars')
        })
    },

    onCloseUserDetailsModal() {
        $('body').on('hidden.bs.modal', function() {
            Livewire.emit('userUpdated')
        })
    },

    createFloorItem(building_id, newItem) {

        let element = document.querySelector(`#input-floor-${building_id}`)
        if(!element) {
            return
        }
        element.value = '';
        var li = document.createElement('li');
        var attr = document.createAttribute('draggable');
        var ul = document.querySelector(`#floors-list-${building_id}`);
        var a = document.createElement('a')
        var span = document.createElement('span')
        var id = uuidv4()

        li.className = 'draggableFloor';
        li.id = `floor-${id}`
        attr.value = 'true';

        a.classList.add('ahref-max')
        a.title = newItem

        li.setAttributeNode(attr);
        li.appendChild(document.createElement('span'))
            .appendChild(a)
            .appendChild(span)
            .appendChild(document.createTextNode(newItem))

        var del = `<svg id="delFloor-${id}" onclick="util.deleteFloorFromHtml('floor-${id}')" style="color:#e46e6a; right: -40px" class="floor-menu right-display svg-inline--fa fa-trash-alt fa-w-14" aria-hidden="true" data-prefix="fas" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><title>${i18next.t( 'delete' )}</title><path fill="currentColor" d="M0 84V56c0-13.3 10.7-24 24-24h112l9.4-18.7c4-8.2 12.3-13.3 21.4-13.3h114.3c9.1 0 17.4 5.1 21.5 13.3L312 32h112c13.3 0 24 10.7 24 24v28c0 6.6-5.4 12-12 12H12C5.4 96 0 90.6 0 84zm416 56v324c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V140c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12zm-272 68c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208z" ></path></svg>`
        li.innerHTML += del
        ul.appendChild(li)
    },

    addNewItem(building_id) {
        var newItem = document.querySelector(`#input-floor-${building_id}`);
        if(!newItem) {
            return
        }
        if (newItem.value != '') {
          util.createFloorItem(building_id, newItem.value)
          initFloors()
        }
    },


    onKeyUpBuildingInputHandler(event, building_id) {
        if(!event.target.value) {
            return
        }
        if (event.keyCode === 13) {
            event.preventDefault();
            util.addNewItem(building_id)
            document.querySelector(`#input-floor-${building_id}`).value = ''
        }

    },

    openBuildingKeyboardShortCutInfoPopup() {
        Swal.fire({
            title: i18next.t( 'keyboard_shortcuts' ),
            iconHtml: '<svg class="svg-inline--fa fa-keyboard fa-w-18" aria-hidden="true" data-prefix="fas" data-icon="keyboard" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor" d="M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"></path></svg>',
            html: `
            <div class="anythinglisting">
                <ul>
                    <li><b>Enter key on floor input: </b><a>`+ i18next.t( 'add_new_floor' ) + `</a></li>
                    <li><b>CTRL/META + A: </b><a>` + i18next.t( 'add_building_name' ) + `</a></li>
                    <li><b>CTRL/META + S: </b><a>`+ i18next.t( 'focus_search_building_input' ) +`</a></li>
                    <li><b>CTRL/META + O: </b><a>`+ i18next.t( 'open_order_buildings_by_popup' ) +`</a></li>
                </ul>
            </div>
            `,
            showConfirmButton: false,
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            }
        })
    },

    openSpaceKeyboardShortCutInfoPopup() {
        Swal.fire({
            title: i18next.t( 'keyboard_shortcuts' ),
            iconHtml: '<svg class="svg-inline--fa fa-keyboard fa-w-18" aria-hidden="true" data-prefix="fas" data-icon="keyboard" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor" d="M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"></path></svg>',
            html: `
            <div class="anythinglisting">
                <ul>
                    <li><b>CTRL/META + S: </b><a>`+ i18next.t( 'focus_search_space_input' ) +`</a></li>
                    <li><b>CTRL/META + O: </b><a>`+ i18next.t( 'open_order_space_by_popup' ) +`</a></li>
                </ul>
            </div>
            `,
            showConfirmButton: false,
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            }
        })
    },

    deleteSpaceLayout(id) {
        api.deleteSpaceLayout(id)
    },

    addSpaceLayout() {
        api.addSpaceLayout(util.getRoomsParams())
    },

    triggerFileInput() {
        $('#background').trigger("click")
    },

    async displayAddBuildingNamePopup() {
        const { value: formValues } = await Swal.fire({
            title: i18next.t( 'add_building_name' ),
            html:
              '<input id="swal-input1" class="swal2-input">',
            focusConfirm: false,
            showCancelButton: false,
            confirmButtonText: i18next.t( 'add' ),
            confirmButtonColor: '#24A0ED',
            preConfirm: () => {
              return document.getElementById('swal-input1').value
            }
        })

        if (formValues) {
            util.setEventLivewire('updateBuilding', {name: formValues, building_id: null, floors: []})
        }
    },

    async displayEditBuildingNamePopup(id, name, organization_id) {
        const { value: formValues } = await Swal.fire({
          title: i18next.t('edit_building_name'),
          html: `
            <label for="name">Building Name</label><br />
            <input id="swal-input1" class="swal2-input" value="${name}"><br />
            <label for="organization_id">Building Organization Id</label><br />
            <input type="number" id="swal-input2" class="swal2-input" value="${organization_id}">
          `,
          focusConfirm: false,
          showCancelButton: false,
          confirmButtonText: i18next.t('edit'),
          confirmButtonColor: '#42BA96',
          preConfirm: () => {
            // Return an object containing the values of the input fields
            return {
              name: document.getElementById('swal-input1').value,
              organization_id: document.getElementById('swal-input2').value,
            };
          },
        });

        if (formValues) {
          util.setEventLivewire('updateBuildingData', { name: formValues.name, building_id: id, organization_id: formValues.organization_id });
        }
    },

    deleteBuilding(id) {
        api.deleteBuilding(id)
    },

    deleteFloorFromHtml(id) {
        var li = document.querySelector(`#${id}`);
        if(!li) {
            return
        }
        li.remove()
        initFloors()
    },

    openUserKeyboardShortCutInfoPopup() {
        Swal.fire({
            title: i18next.t( 'keyboard_shortcuts' ),
            iconHtml: '<svg class="svg-inline--fa fa-keyboard fa-w-18" aria-hidden="true" data-prefix="fas" data-icon="keyboard" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor" d="M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"></path></svg>',
            html: `
            <div class="anythinglisting">
                <ul>
                    <li><b>CTRL/META + S: </b><a>`+ i18next.t( 'focus_search_user_input' ) +`</a></li>
                    <li><b>CTRL/META + O: </b><a>`+ i18next.t( 'open_order_user_by_popup' ) +`</a></li>
                </ul>
            </div>
            `,
            showConfirmButton: false,
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            }
        })
    },

    removeRoom(id) {
        var roomElem = document.getElementById(id);
        roomElem.innerHTML = ''
    },

    addRoom() {
        var id = uuidv4()
        var html = `
                <div id="`+id+`" style="margin-bottom: 20px;">
                <div style="padding:20px; border-radius:10px; border: 1px solid #8080803b;">
                    <svg onclick="util.removeRoom('`+id+`')" class="svg-inline--fa fa-times fa-w-11" aria-hidden="true" data-prefix="fa" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" data-fa-i2svg="" style="
                        float: right; cursor:pointer"><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>
                <div class="form-group" style="margin-top: 0px;">
                    <div class="form-group">
                        <label for="type">`+i18next.t( 'type' )+`</label>
                        <select class="form-control" required id="type-room">
                            <option value disabled="disabled">`+i18next.t( 'choose' )+`</option>
                            <option value="meeting">`+i18next.t( 'meeting' )+`</option>
                            <option value="silent">`+i18next.t( 'silent' )+`</option>
                        </select>
                    </div>
                    </div>
                    <div class="row" style="margin-top: 20px;">
                        <div class="col">
                            <label>`+i18next.t( 'column_start' )+`</label>
                            <input id="column_start-room" class="form-control" type="number" />
                        </div>
                        <div class="col">
                            <label>`+i18next.t( 'row_start' )+`</label>
                            <input id="row_start-room" class="form-control" type="number" />
                        </div>
                    </div>
                    <div class="row" style="margin-top: 20px;">
                        <div class="col">
                            <label>`+i18next.t( 'width' )+`</label>
                            <input class="form-control" id="width-room" type="number" />
                        </div>
                        <div class="col">
                            <label>`+i18next.t( 'height' )+`</label>
                            <input class="form-control" id="height-room" type="number" />
                        </div>
                    </div>
                    <div class="form-group" style="margin-top: 20px;">
                        <label for="door">`+i18next.t( 'door' )+`</label>
                        <select id="door-room" required class="form-control">
                            <option value disabled="disabled">`+i18next.t( 'choose' )+`</option>
                            <option value="top">`+i18next.t( 'top' )+`</option>
                            <option value="bottom">`+i18next.t( 'bottom' )+`</option>
                            <option value="right">`+i18next.t( 'right' )+`</option>
                            <option value="left">`+i18next.t( 'left' )+`</option>
                        </select>
                    </div>
                </div>
            </div>
            </div>
        `
        $("#add_rooms_block").append($.parseHTML(html));
    },


    getRoomsParams() {
        var params = {
            "door": [],
            "type": [],
            "count": 0,
            "width": [],
            "height": [],
            "row_start": [],
            "column_start": []
        }
        Array.from(document.querySelectorAll('#door-room')).forEach(selectedRoomDoor => {
            params["door"].push(selectedRoomDoor.value)
        })
        Array.from(document.querySelectorAll('#type-room')).forEach(selectedRoomType => {
            params["type"].push(selectedRoomType.value)
        })
        params["count"] = params["type"].length
        Array.from(document.querySelectorAll('#width-room')).forEach(selectedRoomWidth => {
            params["width"].push(selectedRoomWidth.value)
        })
        Array.from(document.querySelectorAll('#height-room')).forEach(selectedRoomHeight => {
            params["height"].push(selectedRoomHeight.value)
        })
        Array.from(document.querySelectorAll('#row_start-room')).forEach(selectedRoomRowStart => {
            params["row_start"].push(selectedRoomRowStart.value)
        })
        Array.from(document.querySelectorAll('#column_start-room')).forEach(selectedRoomColumnStart => {
            params["column_start"].push(selectedRoomColumnStart.value)
        })
        return params
    },

    updateSpaceUserData(id) {
        api.updateSpaceUserData({
            id: id,
            auth: $(`#changeAuth-${id}`).val()
        })
    },

    updateOrganizationData(id) {
        api.updateOrganizationData({
            organization_id: id,
            max_spaces: $(`#max_spaces-${id}`).val(),
            max_capacity: $(`#max_capacity-${id}`).val(),
            stripe_customer_id: $(`#stripe_customer_id-${id}`).val(),
            user_billing: $(`#user_billing-${id}`).val(),
            billing_status: $(`#billing_status-${id}`).val(),
            max_window_objects: $(`#max_window_objects-${id}`).val(),
            max_beacon_objects: $(`#max_beacon_objects-${id}`).val(),
            max_seat_objects: $(`#max_seat_objects-${id}`).val(),
            billing_version: $(`#billing_version-${id}`).val(),
            recording_enabled: $(`#recording_enabled-${id}`).val(),
            transcription_enabled: $(`#transcription_enabled-${id}`).val(),
            minutes_enabled: $(`#minutes_enabled-${id}`).val(),
            free_visitor_tickets: $(`#free_visitor_tickets-${id}`).val(),
            paid_visitor_tickets: $(`#paid_visitor_tickets-${id}`).val(),
            max_xl_spaces: $(`#max_xl_spaces-${id}`).val(),
            desktop_app_promotion_enabled: $(`#desktop_app_promotion_enabled-${id}`).val(),
            report_enabled: $(`#report_enabled-${id}`).val(),
            meeting_logs_enabled: $(`#meeting_logs_enabled-${id}`).val() == '1' ? true : false,
            space_access_time_control_enabled: $(`#space_access_time_control_enabled-${id}`).val(),
            campus: $(`#campus-${id}`).val(),
            shield: $(`#shield-${id}`).val(),
            e2ee_enabled: $(`#e2ee_enabled-${id}`).val(),
            message_to_bq_enabled: $(`#message_to_bq_enabled-${id}`).val(),
            contact_center: $(`#contact_center-${id}`).val(),
            notification_banner: $(`#notification_banner-${id}`).val(),
            escalation: $(`#escalation-${id}`).val(),
            nfc_enabled: $(`#nfc_enabled-${id}`).val(),
            insights_for_event: $(`#insights_for_event-${id}`).val(),
            insights_for_option: $(`#insights_for_option-${id}`).val(),
            meeting_log_minutes_enabled: $(`#meeting_log_minutes_enabled-${id}`).val(),
            entry_form: $(`#entry_form-${id}`).val()
        });
    },

    onCloseOrganizationDetailsModal() {
        $('body').on('hidden.bs.modal', function() {
            Livewire.emit('organizationUpdated')
        })
    },

    passManagementParseNumber(value) {
        const normalized = value === null || value === undefined ? '' : String(value).trim();

        if (normalized === '' || normalized === '-') {
            return null;
        }

        const parsed = Number(normalized);

        return Number.isNaN(parsed) ? null : parsed;
    },

    passManagementDeltaIsValid(value) {
        const normalized = value === null || value === undefined ? '' : String(value).trim();

        if (normalized === '' || normalized === '-') {
            return true;
        }

        return !Number.isNaN(Number(normalized));
    },

    passManagementDeltaHasChange(value) {
        const parsed = util.passManagementParseNumber(value);

        return parsed !== null && parsed !== 0;
    },

    passManagementComputeResult(currentValue, deltaValue) {
        const current = util.passManagementParseNumber(currentValue);
        const delta = util.passManagementParseNumber(deltaValue);

        if (current === null && delta === null) {
            return null;
        }

        return Math.max(0, (current ?? 0) + (delta ?? 0));
    },

    passManagementCurrentLimit(id) {
        const raw = $(`#pass_billing_exempt_model_limit-current-${id}`).attr('data-value');

        if (raw === undefined || raw === null) {
            return '';
        }

        return String(raw).trim();
    },

    passManagementLimitInputRaw(id) {
        const value = $(`#pass_billing_exempt_model_limit-${id}`).val();

        return value === null || value === undefined ? '' : String(value).trim();
    },

    passManagementLimitInputIsBlank(id) {
        const value = util.passManagementLimitInputRaw(id);

        return value === '' || value === '-';
    },

    passManagementNumbersEqual(left, right) {
        const leftNumber = Number(left);
        const rightNumber = Number(right);

        if (Number.isNaN(leftNumber) || Number.isNaN(rightNumber)) {
            return String(left) === String(right);
        }

        return leftNumber === rightNumber;
    },

    passManagementLimitIsValid(id) {
        if (util.passManagementLimitInputIsBlank(id)) {
            return true;
        }

        const parsed = Number(util.passManagementLimitInputRaw(id));

        return !Number.isNaN(parsed) && parsed >= 0;
    },

    passManagementLimitHasChange(id) {
        if (!util.passManagementLimitIsValid(id) || util.passManagementLimitInputIsBlank(id)) {
            return false;
        }

        const current = util.passManagementCurrentLimit(id);

        if (current === '') {
            return true;
        }

        return !util.passManagementNumbersEqual(current, util.passManagementLimitInputRaw(id));
    },

    passManagementInputsAreValid(id) {
        const freeDelta = $(`#free_ai_pass_balance_delta-${id}`).val();
        const paidDelta = $(`#paid_ai_pass_balance_delta-${id}`).val();

        return util.passManagementDeltaIsValid(freeDelta)
            && util.passManagementDeltaIsValid(paidDelta)
            && util.passManagementLimitIsValid(id);
    },

    passManagementHasChanges(id) {
        const freeDelta = $(`#free_ai_pass_balance_delta-${id}`).val();
        const paidDelta = $(`#paid_ai_pass_balance_delta-${id}`).val();

        return util.passManagementDeltaHasChange(freeDelta)
            || util.passManagementDeltaHasChange(paidDelta)
            || util.passManagementLimitHasChange(id);
    },

    syncPassManagementBalancePreviews(id) {
        ['free_ai_pass_balance', 'paid_ai_pass_balance'].forEach((prefix) => {
            const $current = $(`#${prefix}-current-${id}`);
            const $delta = $(`#${prefix}_delta-${id}`);
            const $result = $(`#${prefix}_result-${id}`);
            const currentText = $current.text().trim();
            const deltaVal = $delta.val();
            const computed = util.passManagementComputeResult(currentText, deltaVal);

            if (computed === null) {
                $result.text(currentText).addClass('text-muted');

                return;
            }

            $result.text(computed);

            if (util.passManagementDeltaHasChange(deltaVal)) {
                $result.removeClass('text-muted');
            } else {
                $result.addClass('text-muted');
            }
        });
    },

    syncPassManagementLimitPreview(id) {
        const $result = $(`#pass_billing_exempt_model_limit_result-${id}`);
        const current = util.passManagementCurrentLimit(id);

        if (util.passManagementLimitInputIsBlank(id) || !util.passManagementLimitIsValid(id)) {
            $result.text(current).addClass('text-muted');

            return;
        }

        $result.text(util.passManagementLimitInputRaw(id));

        if (util.passManagementLimitHasChange(id)) {
            $result.removeClass('text-muted');
        } else {
            $result.addClass('text-muted');
        }
    },

    resetPassManagementDeltaInputs(id) {
        $(`#free_ai_pass_balance_delta-${id}, #paid_ai_pass_balance_delta-${id}`).val('');
        $(`#pass_billing_exempt_model_limit-${id}`).val('');
        util.syncPassManagementBalancePreviews(id);
        util.syncPassManagementLimitPreview(id);
    },

    syncPassManagementSaveButton(id) {
        const $save = $(`#pass-management-save-${id}`);
        if (!$save.length) {
            return;
        }

        const canSave = util.passManagementHasChanges(id) && util.passManagementInputsAreValid(id);
        $save.prop('disabled', !canSave);
    },

    onPassManagementModalListeners() {
        $('body').on('shown.bs.modal', '[id^="pass-management-"][id$="-detail"]', function() {
            const id = $(this).attr('id').replace('pass-management-', '').replace('-detail', '');
            util.resetPassManagementDeltaInputs(id);
            util.syncPassManagementSaveButton(id);
        });

        $('body').on('input change blur', '[id^="free_ai_pass_balance_delta-"], [id^="paid_ai_pass_balance_delta-"]', function() {
            const $input = $(this);
            const id = $input.attr('id').replace(/^free_ai_pass_balance_delta-/, '').replace(/^paid_ai_pass_balance_delta-/, '');
            util.syncPassManagementBalancePreviews(id);
            util.syncPassManagementSaveButton(id);
        });

        $('body').on('input change blur', '.pass-management-limit-input', function() {
            const id = $(this).attr('id').replace(/^pass_billing_exempt_model_limit-/, '');
            util.syncPassManagementLimitPreview(id);
            util.syncPassManagementSaveButton(id);
        });
    },

    updatePassManagementData(id) {
        if (!util.passManagementHasChanges(id) || !util.passManagementInputsAreValid(id)) {
            return;
        }

        const payload = { organization_id: id };
        const freeDelta = $(`#free_ai_pass_balance_delta-${id}`).val();
        const paidDelta = $(`#paid_ai_pass_balance_delta-${id}`).val();

        if (util.passManagementDeltaHasChange(freeDelta)) {
            payload.free_ai_pass_balance = freeDelta;
        }

        if (util.passManagementDeltaHasChange(paidDelta)) {
            payload.paid_ai_pass_balance = paidDelta;
        }

        if (util.passManagementLimitHasChange(id)) {
            payload.pass_billing_exempt_model_limit = util.passManagementLimitInputRaw(id);
        }

        api.updatePassManagementData(payload);
    },

    onClosePassManagementDetailsModal() {
        $('body').on('hidden.bs.modal', function() {
            Livewire.emit('passManagementUpdated')
        })
    },

    removeOrganizationOwner(id) {
        api.removeOrganizationOwner({
            id: id
        })
    },

    onCloseOrganizationOwnersModal() {
        $('body').on('hidden.bs.modal', function() {
            Livewire.emit('organizationOwnerRemoved')
        })
    },
}

export default util;
